import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { FuseTranslationLoaderService } from 'app/core/services/translation-loader.service';
import { locale as danish } from "./translate/ds";
import { locale as english } from "./translate/en";
import { MatDialog, MatOption, MatSlideToggleChange } from '@angular/material';
import { AuthService } from 'app/core/services/auth.service';
import { SettingsService } from '../../settings.service';
import { ResponseBase } from "app/main/model/ResponseBase";
import { Settings, SettingValue } from "app/main/model/Settings";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CoWorker } from "app/main/model/CoWorker";
import { RequestCoWorker } from "app/main/model/RequestBase";
import { CoWorkersService } from "app/main/pages/coWorker/coWorkers.service";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { SettingEmailTempalteEditorComponent } from "../setting-email-tempalte-editor/setting-email-tempalte-editor.component";

@Component({
    selector: "vibe-planning-notifications-settings",
    templateUrl: "./planning-notifications.component.html",
    styleUrls: ["./planning-notifications.component.scss"]
})

export class PlanningNotificationsSettingsComponent implements OnInit {
    @Input("SendUnPlannedReminderSetting") SendUnPlannedReminderSetting: Settings;
    @Input("CoWokers") CoWokers: CoWorker[];

    showSpinner: boolean = false;
    planningForm: FormGroup;
    isSubmitted = false;
    coWokers: CoWorker[] = [];
    IsGettingCoWokers: boolean = false;
    PlanningNotificationsObj: Settings;
    settingMasterValues: any[] = [];
    settingValue: SettingValue = new SettingValue();
    IsEnable: boolean = true;
    constructor(private translationLoaderService: FuseTranslationLoaderService,
        private fb: FormBuilder,
        private coWorkersService: CoWorkersService,
        private authService: AuthService,
        private settingsService: SettingsService,
        private translate: TranslateService,
        private notificationsService: NotificationsService,
        private dialog: MatDialog) {
        this.translationLoaderService.loadTranslations(danish, english);
    }

    ngOnInit() {
        this.settingMasterValues = Object.assign([], JSON.parse(localStorage.getItem("settingMasterValues")));
        // var coworkerOBJ = new RequestCoWorker();
        // coworkerOBJ.Name = "";
        // this.getCoWorkers(coworkerOBJ);

        this.planningForm = this.fb.group({
            CoworkersID: [null, Validators.required],
            HoursToSend: [null, Validators.compose([Validators.required, Validators.min(1), Validators.max(24)])],
            DaysToSend: [null, Validators.compose([Validators.required, Validators.min(1), Validators.max(365)])],
            IsCreateReminder: [false],
            IsSendSMS: [false],
            IsSendNotification: [false],
            IsSendEmail: [false],
            SMSText: [null],
            NotificationText: [null],
            IsEnable: [true]
        });

        this.planningForm.get('IsSendSMS').valueChanges
            .subscribe(value => {
                if (value) {
                    this.planningForm.controls['SMSText'].setValidators(Validators.required)
                } else {
                    this.planningForm.controls['SMSText'].setValidators(null)
                }
                this.planningForm.controls['SMSText'].updateValueAndValidity()
            });

        this.planningForm.get('IsSendNotification').valueChanges
            .subscribe(value => {
                if (value) {
                    this.planningForm.controls['NotificationText'].setValidators(Validators.required)
                } else {
                    this.planningForm.controls['NotificationText'].setValidators(null)
                }
                this.planningForm.controls['NotificationText'].updateValueAndValidity()
            });


        this.planningForm.controls['CoworkersID'].valueChanges
            .subscribe(selectedCoWorkers => {
            });
        this.setSettingsForPlanningNotifications();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.coWokers = this.CoWokers;
    }


    getCoWorkers(model: RequestCoWorker) {
        model.OrderBy = "Name";
        this.IsGettingCoWokers = true;
        this.coWorkersService.Get<ResponseBase>(model)
            .subscribe((response: ResponseBase) => {
                if (response) {
                    this.coWokers = Object.assign([], response.result);
                    this.getNextRequest(response.pagination, model, response.result);
                }
                else {
                    this.coWokers = [];
                    this.IsGettingCoWokers = false;
                }
            },
                error => (err) => {
                    this.coWokers = [];
                    this.IsGettingCoWokers = false;
                },
                () => {

                });
    }

    getNextRequest(pagination, model, response) {
        if (pagination.index == 1) {
            this.coWokers = Object.assign([], response);
            this.IsGettingCoWokers = false;
        }
        else {
            this.coWokers.push(...response);
            this.IsGettingCoWokers = false;
        }
        model.Index = pagination.index + 1;
        model.Limit = pagination.limit;
        model.TotalRows = pagination.totalCount;
        if (pagination.totalCount > pagination.index * pagination.limit)
            this.getCoWorkers(model);
    }

    DropDownSearchCoWorker(value) {
        if (value != null && value != "") {
            var request = new RequestCoWorker();
            request.Name = value;
            this.getCoWorkers(request);
        } else {
            let coWorker = new RequestCoWorker();
            coWorker.IsDeleted = false;
            this.getCoWorkers(coWorker);
        }
    }

    onSubmit() {
        this.planningForm.markAllAsTouched();
        this.isSubmitted = true;
        if (this.planningForm.valid) {
            this.changeSettingsForPlanningNotifications()
        }
    }

    IsEnableSendUnPlannedReminder(event: MatSlideToggleChange) {
        this.settingValue.IsEnable = event.checked;
        this.changeSettingsForPlanningNotifications();
    }

    setSettingsForPlanningNotifications() {
        if (this.SendUnPlannedReminderSetting && this.SendUnPlannedReminderSetting != null) {
            this.PlanningNotificationsObj = this.SendUnPlannedReminderSetting;
            this.settingValue = JSON.parse(this.SendUnPlannedReminderSetting.value);
            this.planningForm.patchValue(this.settingValue)
            this.planningForm.controls['CoworkersID'].setValue(this.planningForm.controls['CoworkersID'].value.split(','))
            this.changeInLocalStorage(this.PlanningNotificationsObj.id, this.PlanningNotificationsObj)
        }
    }



    setSettingsForPlanningNotificationsAfterUpdate() {
        this.settingsService.GetSettingsWithTemplateValue<ResponseBase>("Notification", 'SendUnPlannedReminder', null).subscribe({
            next: (response: ResponseBase) => {
                this.showSpinner = false;
                if (response != null && response.result && response.result.myResponse.length > 0) {
                    this.PlanningNotificationsObj = response.result.myResponse[0];
                    this.settingValue = JSON.parse(this.PlanningNotificationsObj.value)
                    this.planningForm.patchValue(this.settingValue)
                    this.planningForm.controls['CoworkersID'].setValue(this.planningForm.controls['CoworkersID'].value.split(','))
                    this.changeInLocalStorage(this.PlanningNotificationsObj.id, this.PlanningNotificationsObj)
                }
            },
            error: err => {
            },
            complete: () => {
                this.showSpinner = false;
            }
        });
    }

    changeSettingsForPlanningNotifications() {
        this.showSpinner = true;
        this.settingValue.CoworkersID = this.planningForm.value.CoworkersID.toString();
        this.settingValue.HoursToSend = this.planningForm.value.HoursToSend;
        this.settingValue.DaysToSend = this.planningForm.value.DaysToSend;
        this.settingValue.IsCreateReminder = this.planningForm.value.IsCreateReminder;
        this.settingValue.IsSendSMS = this.planningForm.value.IsSendSMS;
        this.settingValue.IsSendNotification = this.planningForm.value.IsSendNotification;
        this.settingValue.IsSendEmail = this.planningForm.value.IsSendEmail;
        this.settingValue.SMSText = this.planningForm.value.SMSText || '';
        this.settingValue.NotificationText = this.planningForm.value.NotificationText || '';
        this.settingValue.IsEnable = this.planningForm.value.IsEnable;
        this.PlanningNotificationsObj.value = JSON.stringify(this.settingValue);
        this.settingsService.UpdateSettingWithTemplate<ResponseBase>(this.PlanningNotificationsObj).subscribe({
            next: (response: ResponseBase) => {
                this.showSpinner = false;
                if (response != null && response.result) {
                    this.PlanningNotificationsObj = response.result;
                    if (this.settingValue.IsEnable)
                        this.setSettingsForPlanningNotificationsAfterUpdate();
                    this.translate.get("MESSAGES.Saved").subscribe({
                        next: (res) => {
                            this.notificationsService.create(res);
                        },
                        error: err => { }
                    });
                }
            },
            error: err => {
            },
            complete: () => {
                this.showSpinner = false;
                this.isSubmitted = false;
            }
        });
    }

    changeInLocalStorage(ID, new_obj) {
        if (this.settingMasterValues.find(obj => obj.id == ID)) {
            this.settingMasterValues.forEach((old_obj, index) => {
                if (old_obj.id == ID) {
                    this.settingMasterValues[index] = new_obj
                }
            })
        } else {
            this.settingMasterValues.push(new_obj)
        }
        localStorage.setItem("settingMasterValues", JSON.stringify(this.settingMasterValues));
    }

    EmailTemplateDialog() {
        const dialogRef = this.dialog.open(SettingEmailTempalteEditorComponent, {
            height: '90%',
            width: '90%',
            data: { settingValue: this.settingValue, IsOther: false, IsBday: false, IsSameDay: false, Note: 'Note.PlanningEmailTemplateNote' }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result != null && result != '') {
                this.settingValue = result;
                this.onSubmit();
            }
        });
    }
}